import React, { useState } from 'react';
import {
  Button,
  FormSelect,
  FormInput,
  InlineEditColumnProps,
  InlineEditTable,
  Widget,
  FormSubmitButton,
  FormatText,
  MasterDetailForm,
} from '@digital/ui';
import { AcronimoPacote } from '@app/api/acronimosPacote';
import { Collapse, Icon } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';

interface TipoPacoteProps {
  titulo: string;
  data: AcronimoPacote[];
  disciplinas: { text: string; value: string }[] | undefined;
  tipos: { text: string; value: string }[] | undefined;
  handleDelete(id: string): Promise<unknown>;
  handleCreate: (record: AcronimoPacote) => Promise<AcronimoPacote | undefined>;
  handleUpdate: (record: AcronimoPacote) => Promise<boolean>;
  shouldUpdate: (needed: boolean) => void;
  isUpdate: boolean;
}

export const initialState: AcronimoPacote = {
  id: '',
  sigla: '',
  disciplinaId: '',
  tipoId: '',
};

const AcronimoPacoteTableComponent = (props: TipoPacoteProps) => {
  const { titulo, data, disciplinas, tipos, isUpdate, handleCreate, handleUpdate, handleDelete, shouldUpdate } = props;
  const [acronimoPacote, setAcronimoPacote] = useState<AcronimoPacote>(initialState);

  const customColumns = () => {
    return [
      {
        title: 'Sigla',
        dataIndex: 'sigla',
        width: '10%',
        renderEdit: () => <FormInput name="sigla" disabled={false} required />,
      },
      {
        title: 'Disciplina',
        dataIndex: 'disciplinaId',
        key: 'disciplinaId',
        options: disciplinas,
        width: '40%',
        render: (_: string, record: AcronimoPacote) => {
          const option = disciplinas && disciplinas.find(f => f.value === record.disciplinaId);
          return option ? option.text : '';
        },
        renderEdit: () => <FormSelect name="disciplinaId" options={disciplinas} required disabled={false} />,
      },
      {
        title: 'Tipo',
        dataIndex: 'tipoId',
        key: 'tipoId',
        options: tipos,
        width: '40%',
        render: (_: string, record: AcronimoPacote) => {
          const option = tipos && tipos.find(f => f.value === record.tipoId);
          return option ? option.text : '';
        },
        renderEdit: () => <FormSelect name="tipoId" options={tipos} required disabled={false} />,
      },
      {
        render: (item: AcronimoPacote) =>
          hasPermission(['ACRONIMOS_CADASTRAR']) ? (
            <>
              <Button
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                onClick={() => handleDelete(item.id)}
                icon="science-minus"
              />
            </>
          ) : (
              <></>
            ),
      },
    ] as InlineEditColumnProps<AcronimoPacote>[];
  };

  const handleChangeSigla = (sigla: string) => {
    if (sigla.length > 0 && acronimoPacote) {
      setAcronimoPacote({ ...acronimoPacote, sigla });
    }
  };

  const handleChangeDisciplina = (disciplina: SelectValue) => {
    if (disciplina.valueOf && acronimoPacote) {
      setAcronimoPacote({ ...acronimoPacote, disciplinaId: disciplina.toString() });
    }
  };

  const handleChangeTipo = (grupo: SelectValue) => {
    if (grupo.valueOf && acronimoPacote) {
      setAcronimoPacote({ ...acronimoPacote, tipoId: grupo.toString() });
    }
  };

  const handleClick = async () => {
    if (acronimoPacote) {
      const result = await handleCreate(acronimoPacote);
      if (result) {
        !isUpdate ? shouldUpdate(true) : shouldUpdate(false);
      }
    }
  };

  const { Panel } = Collapse;

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Acrônimos Pacote" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                hasPermission(['ACRONIMOS_CADASTRAR', 'ACRONIMOS_EDITAR']) && (
                  <FormSubmitButton type="primary" onClick={handleClick}>
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <InlineEditTable
                className="removeScrollbar"
                rowKey="id"
                columns={customColumns()}
                updateItem={handleUpdate}
                dataSource={data}
                pagination={false}
                disablenotification={false}
              />
              <fieldset>
                <legend>Inserir Nova Linha</legend>
                <FormInput span={3} label="Sigla" name="sigla" onChange={e => handleChangeSigla(e.target.value)} />
                <FormSelect
                  showSearch
                  label="Disciplina"
                  name="disciplinaId"
                  options={disciplinas}
                  span={4}
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  onSelect={e => handleChangeDisciplina(e)}
                />
                <FormSelect
                  showSearch
                  label="Tipo"
                  name="tipoId"
                  options={tipos}
                  span={4}
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  onSelect={e => handleChangeTipo(e)}
                />
              </fieldset>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default AcronimoPacoteTableComponent;
